import { render, staticRenderFns } from "./EditMediaModal.vue?vue&type=template&id=08492d0b&scoped=true&"
import script from "./EditMediaModal.vue?vue&type=script&lang=js&"
export * from "./EditMediaModal.vue?vue&type=script&lang=js&"
import style0 from "./EditMediaModal.vue?vue&type=style&index=0&id=08492d0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08492d0b",
  null
  
)

export default component.exports